"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripUpdateStoryCategory = void 0;
exports.TripUpdateStoryCategory = {
    DEPARTURE_DATE_UPDATE: 'DEPARTURE_DATE_UPDATE',
    ADDRESS_UPDATE: 'ADDRESS_UPDATE',
    PANEL_UPDATE: 'PANEL_UPDATE',
    FREE_FARE_UPDATE: 'FREE_FARE_UPDATE',
    PASSENGER_UPDATE: 'PASSENGER_UPDATE',
    COMMENT_UPDATE: 'COMMENT_UPDATE',
    TRANSPORT_UPDATE: 'TRANSPORT_UPDATE',
    PRICE_UPDATE: 'PRICE_UPDATE',
    CHANGE_DRIVER: 'CHANGE_DRIVER',
};
